import { Colors } from '@cognite/cogs.js';

export const lightGrey = Colors['border--muted'];
